import { createApp } from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'
import '../src/assets/style.css'
import i18n from './i18n'
import VueCarousel from 'vue-carousel';
import { IonIcon, IonicVue } from '@ionic/vue';

const app = createApp(App).use(store).use(router).use(i18n).use(VueCarousel).use(IonicVue)
app.component('ion-icon', IonIcon);
app.mount('#app')
